export const generateCareerRandomImageId = ({
  max = 6,
}: { max?: number } = {}) => {
  // NOSONAR: Math.random() is used only for visual randomness
  
  return Math.floor(Math.random() * max) + 1;
};
